import FinancierOverview from "../../components/financier/overview/FinancierOverview";
import FinancierSharedView from "../shared/FinancierSharedView";
import { observer } from "mobx-react-lite";

export default observer(function FinancierDashboard() {
  return <FinancierSharedView mainContent={<FinancierOverview />} />;
});
